import React, { useState } from 'react'

import CloseDialogIconButton from 'src/components/iconbutton/CloseDialogIconButton.js'
import NmotTranslationText from 'src/views/nmot/shared/NmotTranslationText'
import EditNmotUserDialogContext from './EditNmotUserDialogContext.js'
import EditNmotUserDialogForm from './EditNmotUserDialogForm.js'
import Paper from '@material-ui/core/Paper'
import { components } from 'cng-web-lib'

const { CngDialog } = components

function EditNmotUserDialog({
  isDialogOpen,
  closeDialog,
  rowData,
  showNotification,
  cngTableRef,
  validUserList
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const translatedTextsObject = NmotTranslationText()

  return (
    <EditNmotUserDialogContext.Provider
      value={{
        closeDialog,
        showNotification,
        rowData,
        form: {
          isSubmitting,
          setSubmitting
        },
        cngTableRef,
        validUserList
      }}
    >
      <CngDialog
        customDialogContent={
          <Paper>
            <div style={{ overflow: 'hidden' }}>
            <EditNmotUserDialogForm />
            </div>
          </Paper>
        }
        dialogTitle={
          <>
            {translatedTextsObject.editNmotUserTitle}
            <CloseDialogIconButton
              onClick={closeDialog}
              disabled={isSubmitting}
            />
          </>
        }
        open={isDialogOpen}
        fullWidth
        maxWidth='sm'
      />
    </EditNmotUserDialogContext.Provider>
  )
}

export default EditNmotUserDialog